<template>
  <div>
    <ToggleSwitch
      v-model="settings.international"
      :disabled="hasCustomDomainConfiguration"
      label="SA.shopsettings.international.language.all.label"
    />

    <div
      v-if="hasCustomDomainConfiguration"
      class="custom-domain-info-internalisation"
    >
      <small>
        {{ $t('SA.shopsettings.international.shopCustomDomainDescription') }}
      </small>
    </div>

    <div class="sprd-shop-input">
      <Dropdown
        :items="localization.languages"
        :item-key="(lang) => lang.id"
        :item-to-string="(lang) => lang.name"
        :label="$t('SA.shopsettings.international.language.label')"
        :value="currentLanguage"
        :disabled="settings.international"
        @change="setLanguage"
      />
    </div>

    <div class="shop-currency sprd-shop-input">
      <Dropdown
        :items="localization.currencies"
        :item-key="(cur) => cur.id"
        :item-to-string="(cur) => cur.isoCode"
        :label="$t('SA.shopsettings.international.currency.label')"
        :value="currentCurrency"
        :disabled="!config.shopCurrencyEditable"
        @change="setCurrency"
      />
    </div>

    <div>
      <small>{{ $t('SA.shopsettings.international.currency.info') }}</small>
    </div>

    <ToggleSwitch
      v-if="!newStorefront"
      v-model="shopLinked"
      :label="label"
      :disabled="!settings.international"
    />

    <div v-if="!newStorefront" class="linked-shop">
      <ValidLabelInput
        v-model="settings.linkedShopName"
        :label="$t('SA.shopDashboard.shopId.label')"
        :disabled="!helperActive"
        :validators="[validateLinkedShopName]"
        class="sprd-shop-input"
        maxlength="200"
      />
      <div v-tooltip="helperActive ? { content: $t(info) } : false">
        <Icon
          :class="{
            helpIcon: true,
            helpIconActive: helperActive,
            disabledThing: !helperActive,
          }"
          icon="info-circle"
        />
      </div>
    </div>

    <p
      v-if="!newStorefront"
      :class="{ disabledThing: !settings.international }"
    >
      {{ $t(description) }}
    </p>
  </div>
</template>

<script>
import { SettingsData } from 'src/app/partnerarea/pos/shop/shopSavable/SettingsData';
import { shopAPI } from 'commons/api/shop/shopAPI.js';

import ValidLabelInput from '../../shop/common/ValidLabelInput.vue';
import Dropdown from '../../../../commons/Dropdown/Dropdown.vue';
import ToggleSwitch from 'commons/toggleSwitch/ToggleSwitch.vue';
import { validateShopName } from '../../../shop/create/validateShopName';

export default {
  name: 'ShopLanguageAndCurrency',
  components: {
    Dropdown,
    ValidLabelInput,
    ToggleSwitch,
  },
  mixins: [SettingsData],
  data: function () {
    const isEU = SPRD.PLATFORM === 'EU';
    const linkedShopName =
      this.$store.state.shop.shopSavable.clientData.settings.linkedShopName;
    return {
      localization: {},
      label: isEU
        ? 'SA.shopsettings.international.naShop'
        : 'SA.shopsettings.international.euShop',
      info: isEU
        ? 'SA.shopsettings.international.linkedNaShopInfo'
        : 'SA.shopsettings.international.linkedEuShopInfo',
      description: isEU
        ? 'SA.shopsettings.international.naShopConnectionDescription'
        : 'SA.shopsettings.international.euShopConnectionDescription',
      shopLinked: Boolean(linkedShopName),
    };
  },
  computed: {
    currentLanguage() {
      if (!this.localization.languages) {
        return null;
      }
      return this.localization.languages.find(
        (lang) => lang.id === this.config.shopLanguage,
      );
    },
    currentCurrency() {
      if (!this.localization.currencies) {
        return null;
      }
      return this.localization.currencies.find(
        (curr) => curr.id === this.config.shopCurrency,
      );
    },
    helperActive() {
      return this.settings.international && this.shopLinked;
    },
    hasCustomDomainConfiguration() {
      return this.$store.state.shop.customDomain.data !== undefined;
    },
  },
  watch: {
    shopLinked: function (newValue) {
      if (!newValue) {
        this.settings.linkedShopName = '';
      }
    },
  },
  created: function () {
    this.$store.commit('shop/setLivePreview', { path: '' });
    if (SPRD.PLATFORM === 'NA') {
      this.$store.dispatch('shop/getCustomDomain');
    }
    shopAPI
      .getLocalization(this.$store)
      .then((loc) => (this.localization = loc))
      .catch((e) => console.error('Failed to load localization', e));
  },
  methods: {
    setLanguage(lang) {
      this.config.shopLanguage = lang.id;
    },
    setCurrency(curr) {
      this.config.shopCurrency = curr.id;
    },
    validateLinkedShopName(shopName) {
      if (
        !shopName || // no linked shop
        /^\d+$/.test(shopName) || // Shop-ID
        validateShopName(shopName) // Shop name
      ) {
        return;
      }

      throw new Error(this.$t('ACCOUNT.ERRORS.INVALID_FORMAT'));
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';

.shop-currency {
  margin-bottom: 5px;
}

.linked-shop {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 5px;

  .sprd-shop-input {
    flex-grow: 1;
    margin: 0;
  }
}

.helpIcon {
  height: 30px;
  width: 30px;
  margin-left: 10px;
}

.helpIconActive {
  color: $pa-color-main;
}

.disabledThing {
  color: #aaa;
}

.custom-domain-info-internalisation {
  margin: -12px 0px 24px 0px;
}
</style>
